import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const iconButtonVariants = cva(
	"inline-flex items-center justify-center rounded-md " +
		"transition-colors duration-150 " +
		"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/30 " +
		"disabled:opacity-50 disabled:cursor-not-allowed",
	{
		variants: {
			size: {
				xs: "w-6 h-6",
				sm: "w-7 h-7",
				md: "w-8 h-8",
			},
			tone: {
				default:
					"text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white " +
					"hover:bg-gray-100 dark:hover:bg-white/[0.06]",
				danger:
					"text-gray-500 dark:text-gray-400 " +
					"hover:text-red-600 dark:hover:text-red-400 " +
					"hover:bg-red-50 dark:hover:bg-red-500/10",
				accent:
					"text-gray-500 dark:text-gray-400 " +
					"hover:text-orange-600 dark:hover:text-amber-300 " +
					"hover:bg-orange-50 dark:hover:bg-amber-400/[0.08]",
			},
		},
		defaultVariants: {
			size: "sm",
			tone: "default",
		},
	},
);

export interface IconButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof iconButtonVariants> {}

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
	({ className, size, tone, type = "button", ...props }, ref) => {
		return (
			<button
				ref={ref}
				type={type}
				className={cn(iconButtonVariants({ size, tone, className }))}
				{...props}
			/>
		);
	},
);
IconButton.displayName = "IconButton";

export { IconButton, iconButtonVariants };
